module.exports = __webpack_public_path__ + "img/water_droplet_8.b33eac58.svg";